/*----- Core -----*/
import React       from 'react'
import { connect } from "react-redux"
import ReactPixel  from 'react-facebook-pixel'

/*----- Selectors -----*/
import { emailToProducerIsLoadingSelector } from '../Selectors'

/*----- Actions -----*/
import { sendEmailToProducer } from '../Actions'

/*----- Components -----*/
import InputContainer from '../../../components/form/InputContainer'
import HandlerButton  from '../../../components/button/HandlerButton'
import Spinner        from '../../../components/commons/Spinner'
import HeroParagraph  from '../../../components/hero/HeroParagraph'

/*----- Ant design -----*/
import { Form, Input, InputNumber } from 'antd'


function ProducerContactForm({ sendEmailToProducer, emailToProducerIsLoading }) {

	const [form]= Form.useForm()

	const onFinish = (values) => {
		sendEmailToProducer(values)
		form.resetFields()
		ReactPixel.track('Lead')
	}
	
	if(emailToProducerIsLoading) {
		return <Spinner />
	}

	return (
		<Form
			layout				 = "vertical"
			name           =  "producer-contact-form"
			initialValues  = {{ remember: true }}
			onFinish       = {onFinish}
			form           = { form }
		>

		<HeroParagraph title="¿Querés cotizar?" />

		<InputContainer>
			<Form.Item
				label	=	"Nombre completo"
				name 	=	"name"
				rules	=	{[{required: true, message: 'Ingresá tu nombre completo'}]}
			>
				<Input size="large" placeholder="Ingresá tu nombre completo"/>
			</Form.Item>
		</InputContainer>

		<InputContainer>
			<Form.Item
				label	=	"Celular"
				name 	=	"phone_number"
				rules	=	{[{required: true, message: 'Ingresá tu número de teléfono'}]}
			>
				<InputNumber style={{width: '100%'}} size="large" placeholder="Ingresá tu número de celular" />
			</Form.Item>
		</InputContainer>

		<InputContainer>
			<Form.Item
				label	=	"Email"
				name 	=	"email"
				rules	=	{[{required: true, type: 'email', message: 'Ingresá un mail válido'}]}
			>
				<Input size="large" placeholder="Ingresá tu e-mail"/>
			</Form.Item>
		</InputContainer>
		
		<InputContainer>
			<Form.Item className="button-container">
				<HandlerButton content="COTIZÁ" htmlType="submit"/>
			</Form.Item>
		</InputContainer>

	</Form>
	)
}

const mapStateToProps = (state) => {
  return {
		emailToProducerIsLoading: emailToProducerIsLoadingSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		sendEmailToProducer: (params) => sendEmailToProducer(dispatch, params)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProducerContactForm)
